import axios from "axios";
const jsonConfig = require("../../Config.json");

const getSkills = async () => {
  try {
    const getAllResponse = await axios.get(jsonConfig.apiUrl + "skills", {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getSkills;
